export default {
  bibo: "http://purl.org/ontology/bibo/",
  bio: "http://vocab.org/bio/0.1/",
  "bnf-onto": "http://data.bnf.fr/ontology/bnf-onto/",
  bnfroles: "http://data.bnf.fr/vocabulary/roles/",
  dawgt: "http://www.w3.org/2001/sw/DataAccess/tests/test-dawg#",
  dbpedia: "http://dbpedia.org/resource/",
  dbpprop: "http://dbpedia.org/property/",
  dc: "http://purl.org/dc/elements/1.1/",
  "dcmi-box": "http://dublincore.org/documents/dcmi-box/",
  dcmitype: "http://purl.org/dc/dcmitype/",
  dcterms: "http://purl.org/dc/terms/",
  fn: "http://www.w3.org/2005/xpath-functions/#",
  foaf: "http://xmlns.com/foaf/0.1/",
  "frbr-rda": "http://rdvocab.info/uri/schema/FRBRentitiesRDA/",
  genremus: "http://data.bnf.fr/vocabulary/musical-genre/",
  geo: "http://www.w3.org/2003/01/geo/wgs84_pos#",
  geonames: "http://www.geonames.org/ontology#",
  go: "http://purl.org/obo/owl/GO#",
  ign: "http://data.ign.fr/ontology/topo.owl#",
  insee: "http://rdf.insee.fr/geo/",
  isni: "http://isni.org/ontology#",
  marcrel: "http://id.loc.gov/vocabulary/relators/",
  math: "http://www.w3.org/2000/10/swap/math#",
  mesh: "http://purl.org/commons/record/mesh/",
  mf: "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  mo: "http://musicontology.com/",
  nci: "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
  obo: "http://www.geneontology.org/formats/oboInOwl#",
  ore: "http://www.openarchives.org/ore/terms/",
  owl: "http://www.w3.org/2002/07/owl#",
  product: "http://www.buy.com/rss/module/productV2/",
  protseq: "http://purl.org/science/protein/bysequence/",
  rdagroup1elements: "http://rdvocab.info/Elements/",
  rdagroup2elements: "http://rdvocab.info/ElementsGr2/",
  rdarelationships: "http://rdvocab.info/RDARelationshipsWEMI/",
  rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
  rdfa: "http://www.w3.org/ns/rdfa#",
  rdfdf: "http://www.openlinksw.com/virtrdf-data-formats#",
  rdfs: "http://www.w3.org/2000/01/rdf-schema#",
  sc: "http://purl.org/science/owl/sciencecommons/",
  schemaorg: "http://schema.org/",
  scovo: "http://purl.org/NET/scovo#",
  sd: "http://www.w3.org/ns/sparql-service-description#",
  sioc: "http://rdfs.org/sioc/ns#",
  skos: "http://www.w3.org/2004/02/skos/core#",
  sql: "sql:",
  vcard: "http://www.w3.org/2001/vcard-rdf/3.0#",
  vcard2006: "http://www.w3.org/2006/vcard/ns#",
  virtcxml: "http://www.openlinksw.com/schemas/virtcxml#",
  virtrdf: "http://www.openlinksw.com/schemas/virtrdf#",
  void: "http://rdfs.org/ns/void#",
  xf: "http://www.w3.org/2004/07/xpath-functions",
  xml: "http://www.w3.org/XML/1998/namespace",
  xsd: "http://www.w3.org/2001/XMLSchema#",
  xsl10: "http://www.w3.org/XSL/Transform/1.0",
  xsl1999: "http://www.w3.org/1999/XSL/Transform",
  xslwd: "http://www.w3.org/TR/WD-xsl",
  yago: "http://dbpedia.org/class/yago/",
};
